// Announcement
export const ANNOUNCEMENT = "announcements";

// Auth
export const CHANGE_PASSWORD = "auth/change-password/";
export const FORGET_PASSWORD = "auth/forget-password/";
export const LOGIN = "auth/login/";
export const REGISTER = "auth/signup/";
export const RESET_PASSWORD = "auth/reset-password/";

// Customer Success
export const ASSIGNED_USERS = "salesrep/assigned/";
export const VERIFIED_USERS = "salesrep/verified/";

// BOM Generator
export const BOM_GENERATOR = "bom-generator/";

// Custom Panels
export const CUSTOM_PANELS = "custom-panels/";

// Design Detail
export const DESIGN_DETAILS = "design-detail/";

// Key Metrics
export const KEY_METRICS = "key-metrics/";

// Quote
export const QUOTES = "quote/";

// Search Genes & Fusions
export const SEARCH_GENE_FUSION = "search-genes-fusion/";
// Search Targets
export const SEARCH_TARGETS = "search/targets/";

// Target Upload
export const TARGET_UPLOAD = "upload/";
// Design Upload
export const DESIGN_UPLOAD = "design-upload";
export const DESIGN_UPLOAD_VALIDATE = "design-upload-validate/";

export const DESIGNS = "designs/";
export const DISEASE_TYPES = "disease-type/";
export const WORKFLOWS = "workflow/";

// Downloads
export const GTF_FILE = "gtf/design";
export const BED_FILE = "design-target/design";
export const CTF_FILE = "primer-pair/design";
export const PRODUCT_INSERT = "productinsert-generator/";

// Kits
export const KITS = "kits/";

// Preferences
export const PREFERENCES = "user/preferences/";
